export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Buscar',
  marketplaceDetailsCurtainCopyOptionTitle: 'Copiar enlace',
  marketplaceDetailsCurtainFlagOptionTitle: 'Reportar contenido',
  marketplaceDetailsCurtainCopiedAlertText: 'Enlace copiado!',
  marketplaceDetailsFlagCurtainTitle: 'Reportar',
  marketplaceReportedCurtainContent: 'Contenido reportado',
  marketplaceAllItems: 'Todos los artículos',
  marketplaceWantToBuy: 'Quiero comprar {item} de {appname}'
}
